function quickOrderList() {
  /* **************************************************************
    function updateCartBubbles
    fetch cart content and update quantities and cart total to cart link, and
    quantities to the product list
    ************************************************************** */

    updateCartBubbles = function() {

      fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json()).then(cart => {

      let cartLinkBubble = document.querySelector('.cart-link__bubble'),
          cartLinkPrice =  document.querySelector('.cart-link__price');

      // update quantity and total to cart link on the header

      if (cart.items.length > 0) {
            
            cartLinkBubble.textContent = cart.item_count;
            cartLinkBubble.classList.add('cart-link__bubble--visible');

            cartLinkPrice.textContent = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
            cartLinkPrice.classList.remove('hide');
      } else {
            cartLinkBubble.textContent = '';
            cartLinkBubble.classList.remove('cart-link__bubble--visible');
            cartLinkPrice.textContent = '';
            cartLinkPrice.classList.add('hide');
      }

      // update quantity bubbles on product list
      var orderForm = document.getElementById('productsForm');
      var inactiveBubbles = Array.from(orderForm.querySelectorAll('.cart-link__bubble--order-form:not(.hidden)'));

      for (var i=0; i < cart.items.length; i++) {

        let itemId = cart.items[i].id;
        let itemQty = cart.items[i].quantity;

        let bubbleId = 'count_' + itemId;
        var bubble = document.getElementById(bubbleId);

        if(inactiveBubbles.includes(bubble)) {
          let bubbleIndex = inactiveBubbles.indexOf(bubble);
          inactiveBubbles.splice(bubbleIndex, 1);
        }

        if ( typeof(bubble) != 'undefined' && bubble != null ){
          bubble.innerHTML = itemQty.toString();
          bubble.classList.remove('hidden');
          bubble.classList.add('cart-link__bubble--visible');
        }
      }

      // remove inactive bubbles
      for (var i=0; i < inactiveBubbles.length; i++) {
        var inactiveBubble = inactiveBubbles[i];
        if ( typeof(inactiveBubble) != 'undefined' && inactiveBubble != null ){
          inactiveBubble.innerHTML = '';
          inactiveBubble.classList.add('hidden');
          inactiveBubble.classList.remove('cart-link__bubble--visible');
        }
      }

    });  
  };

  /* **************************************************************
  function  resetQuantityInputs
    Set all quantityInput values to default value, a.k.a reset form
  ************************************************************** */

  resetQuantityInputs = function() {
    document.getElementById("productsForm").reset();
  }

  /* **************************************************************
  function buildAddToCartQueue(orderItems, scope)
    builds array (variant id, quantity) for fetching products to cart

    orderItems:
    array of quantity inputs

    scope:
    if scope = 'all' quantity input's step value (=sales lot quantity) is used as quantity
    else input value is used

  ************************************************************** */

  buildAddToCartQueue = function(orderItems, scope='selected') {

    let addToCartQueue = { 
    "items" : []
    }

    for (var i = 0; i < orderItems.length; i++) {
      // get item id
      let itemId = orderItems[i].id.replace('Quantity-','');
      var itemQuantity = 0;

      /* get quantities */
      if(scope === 'selected'){
        itemQuantity = parseInt(orderItems[i].value);
      } else {

        // if all products from page is added, quantity is sales lot quantity if variant balance is enough
        let max = parseInt(orderItems[i].getAttribute('max'));
        let step = parseInt(orderItems[i].getAttribute('step'));

        if(max >= step) {
          itemQuantity = step;
        } else {
          itemQuantity = 0;
        }
      }
      
      /* add item to array */
      if (itemQuantity > 0) {
        addToCartQueue.items.push(
          {
            id: itemId,
            quantity: itemQuantity
          }
        );
      };
    };

    return addToCartQueue;
  };

  /* **************************************************************
  function fetchDataToCart(data)

  fetches data to cart

    data:
    array of items to add to cart

  data = {
      "items": [
        { id: id, quantity: quantity}
      ]
    }
  ************************************************************** */

  fetchDataToCart = function(data) {
    var loader = document.querySelector('.quick-order-loader-overlay');

    // if only single item is added, updates single message element 
    if(data.items.length == 1) {
      var singleItemId = data.items[0].id;
      var messages = document.querySelectorAll("[data-message='"+ singleItemId +"']");
    } else {
      // if multiple items is added, update whole form message element 
      var messages = document.querySelectorAll("[data-form-message]");
      loader.classList.add('visible');
    }
    // clear existing messages if exists
    if(messages.length > 0) {
      clearMessages();
    }

    if(typeof(data) == 'object') {
      data = JSON.stringify(data);
    }

    // post data to cart

    fetch('/cart/add.js', {
      body: data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then(function(response) {
      loader.classList.remove('visible');

      if (response.status == 200) {
        // everything is ok
        resetQuantityInputs();
        updateCartBubbles();
      }
      showMessages(messages, response.status);

    }).catch(function(err) {
      loader.classList.remove('visible');
      console.error(err)
    });
  }

  /* **************************************************************
  function clearMessages
  clear all form and product row messages if exists
  ************************************************************** */

  clearMessages = function() {
    var formMessages = Array.from(document.querySelectorAll("[data-form-message]"));
    var singleMessages = Array.from(document.querySelectorAll("[data-message]"));

    var messages = formMessages.concat(singleMessages);

    for (var i = 0; i < messages.length; i++) {
      messages[i].innerHTML = '';
      messages[i].classList.add('hidden');
    }
  }

  /* **************************************************************
  function showMessages
  shows messages when product/ products is added to cart

  messages: array of message elements to show
  response:  shopify response from fetch items to cart function
  ************************************************************** */

  showMessages = function(messages, response) {

    var messageText,
        messageClasses;

    if(response == 200) {
      // everything went ok when added to cart
      messageText = '<i class="fa fa-check"></i>' + feedbackMessages.addedToCartText + ' <a href="/cart">' + feedbackMessages.viewCartText + '</a>';
      messageClasses ="success";
    } else {
      // something went wrong, show error and response status number
      messageText = '<i class="fa fa-warning"></i>' + feedbackMessages.addToCartFailedText;
      messageClasses ="error";
    }

      // update message text and show messages
    for (var i = 0; i < messages.length; i++) {
      messages[i].innerHTML = messageText;
      messages[i].classList.remove('error','success');
      messages[i].classList.add(messageClasses);
      messages[i].classList.remove('hidden');
    }
  };

  /* **************************************************************
  function addProducts

  just controls add to cart flow

  el: wrapper element that contains all quantity inputs to add to cart. for single product it's quantity input's wrapper,
      for multiple products it's form contains all products

  scope:  "single", "selected, "all" products
  tells scope to buildAddToCartQueue -function
  ************************************************************** */

  addProducts = function(el,scope) {
    var orderItems = Array.from(el.querySelectorAll('input[name="quantity"]')),
    data;

    if(orderItems.length > 0){
      if( scope==='all' ){
        data = buildAddToCartQueue(orderItems,'all');
      } else {
        data = buildAddToCartQueue(orderItems);
      }

      fetchDataToCart(data);
    }
  }

  /* **************************************************************
  function validateValue
  validates input value based on sales lot quantity and variant balance

  input: input element to validate

  ************************************************************** */

  validateValue = function(input){

      var inputMax = parseInt(input.getAttribute('max'));
      var inputStep =  parseInt(input.getAttribute('step'));
      var inputValue = parseInt(input.value);
      var calculatedValue = parseInt(input.value);
      var tooltip = document.querySelector("[data-tooltip-for='" + input.id + "']");

      if(inputValue > inputMax) {
        calculatedValue = inputMax;
      }
      
      if(calculatedValue % inputStep !== 0){
        calculatedValue = calculatedValue - (calculatedValue % inputStep);  
      }

      if(calculatedValue !== inputValue){
        if(calculatedValue > 0){
          input.value = calculatedValue;
        } else {
          input.value = inputStep;
        }

        tooltip.innerHTML = feedbackMessages.quantityModifiedText;
        tooltip.classList.remove('hidden');
      }
    }

  /* **************************************************************
  Event listeners
  ************************************************************** */

    var orderForm = document.getElementById('productsForm');
    var qtySelectors = orderForm.querySelectorAll('.js-qty__wrapper');
    var addToCartButtons = document.querySelectorAll("[data-action='add-single']");
    var addCollectionButtons = document.querySelectorAll("[data-action='add-all-from-page']");
    var addSelectedButtons = document.querySelectorAll("[data-action='add-selected']");
    var tooltips = document.querySelectorAll("[data-tooltip-for]");

    // prevent form submit
    orderForm.addEventListener('submit',function(e){e.preventDefault()},false);

    /* init quantity selectors with theme's own functions */
    for (var i = 0; i < qtySelectors.length; i++) {
      var selector = new theme.QtySelector($(qtySelectors[i]), {
        namespace: '.quick-order-list'
      });

    /* event listerens for quantity selectors */
    var input = qtySelectors[i].querySelector("[name='quantity']");
      input.addEventListener('change', function (e) {
        validateValue(this);
      });
    };

    /* event listeners for add single product buttons */
    for (var i = 0; i < addToCartButtons.length; i++) {

      addToCartButtons[i].addEventListener('click', function (e) {
          addProducts(this.closest('.product__quantity'),'single');
      });
    };

    /* event listeners for add selected products buttons */
    for (var i = 0; i < addSelectedButtons.length; i++) {
      addSelectedButtons[i].addEventListener('click', function (e) {        
        addProducts(orderForm,'selected');
      });
    };

    /* event listeners for add all products from page buttons */
    for (var i = 0; i < addCollectionButtons.length; i++) {
      addCollectionButtons[i].addEventListener('click', function (e) {        
        addProducts(orderForm,'all');
      });
    };

    /* event listener for tooltips */
    for (var i = 0; i < tooltips.length; i++) {
      tooltips[i].addEventListener('click', function (e) {
        this.innerHTML = '';
        this.classList.add('hidden');
      });
    };

    /* event listener for form submit */
    orderForm.addEventListener('submit', function(){
      return false;
    });

    /* 
    listener for theme's own custom event
    uncomment if minicart is in use 
    
    
    $('body').on('updateCart.ajaxcart',function(evt, cart) {
      updateCartBubbles();
    });

    */

}
